import { PEV } from "../../../../../../common/utils";
import * as service from "./service";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { usersTab } from "../../../model";

const emptyUserAccess = () => ({
  data: PEV({
    columns: [],
    dataSource: [],
  }),
  appId: null,
});

const initialState = {
  userAccesses: [],
};

const findUserAccessIndexByAppId = (state, appId) =>
  state.userAccesses.findIndex((ua) => ua.appId === appId);

const getApplicationUserAccess = createAsyncThunk(
  "applications/user-access/fetch",
  async (appId) => {
    return await service.getAppUserAccess(appId);
  }
);

export const AppUserAccessSlice = createSlice({
  name: "appUserAccess",
  initialState,
  reducers: {
    resetUserAccessdata(state) {
      state.userAccesses = initialState.userAccesses;
    },
  },
  extraReducers: {
    [getApplicationUserAccess.pending.type]: (state, pendingAction) => {
      const appId = pendingAction.meta.arg;
      const userAccessIndex = findUserAccessIndexByAppId(state, appId);
      const emptyAccess = { ...emptyUserAccess(), appId };
      emptyAccess.data.progress = "Fetching application user access data";
      if (userAccessIndex === -1) {
        state.userAccesses.push(emptyAccess);
      } else {
        state.userAccesses[userAccessIndex] = emptyAccess;
      }
    },
    [getApplicationUserAccess.fulfilled.type]: (state, action) => {
      const appId = action.meta.arg;
      const userAccessIndex = findUserAccessIndexByAppId(state, appId);
      state.userAccesses[userAccessIndex].data = PEV(action.payload);
    },
    [getApplicationUserAccess.rejected.type]: (state, rejectedAction) => {
      const appId = rejectedAction.meta.arg;
      const userAccessIndex = findUserAccessIndexByAppId(state, appId);
      state.userAccesses[userAccessIndex].data.progress = null;
      state.userAccesses[userAccessIndex].data.error = rejectedAction.error;
    },
  },
});

export const findUserAccessByAppId = (state, appId) =>
  state.userAccesses.find((ua) => ua.appId === appId);
export const getCurrentModelState = () => window.store.getState().appUserAccess;
export const getUserAccessColumns = (appId) =>
  findUserAccessByAppId(getCurrentModelState(), appId)?.data?.value?.columns ?? [];

export const AppUserAccessReducer = AppUserAccessSlice.reducer;
const { resetUserAccessdata } = AppUserAccessSlice.actions;
export const AppUserAccessActions = { getApplicationUserAccess, resetUserAccessdata };

export const getUserAccessTableId = (appId) => `${usersTab.id}-${appId}`;
